import * as types from "./types";

interface menuCountProps {
  count: number;
  menuId: string;
}

export const menuInitialState = {
  //Count for All Order
  menuCount: [] as menuCountProps[],

  menus: [],
  menusLoading: false,
  menusError: null,

  menu: {},
  menuLoading: false,
  menuError: null,

  postMenuLoading: false,
  postMenuError: null,
};

export const menuReducer = (state = menuInitialState, action: any) => {
  // console.log(state);
  switch (action.type) {
    case types.increment:
      const includeFoodIds = state.menuCount.some(
        (item: any) => item.menuId === action.menuId
      );
      // console.log(includeFoodIds);
      // console.log(state.menuCount);
      if (includeFoodIds) {
        // const newCount = state.menuCount.find((item))
        const newCount = state.menuCount.map((item: any) => {
          return {
            count:
              item.menuId === action.menuId
                ? item.count >= action.quantity
                  ? item.count
                  : item.count + 1
                : item.count,
            menuId: item.menuId,
          };
        });
        // console.log(newCount);

        return {
          ...state,
          ...state.menuCount,
          menuCount: newCount,
        };
      }

      return {
        ...state,
        menuCount: [
          ...state.menuCount,
          {
            count: 1,
            menuId: action.menuId,
          },
        ],
      };

    case types.decrement:
      const menuIdR = action.menuId;
      const includeFoodIdds = state.menuCount.some(
        (item: any) => item.menuId === menuIdR
      );
      console.log(includeFoodIdds);
      console.log(state.menuCount);
      if (includeFoodIdds) {
        // const newCount = state.menuCount.find((item))
        const newCount = state.menuCount.map((item: any) => {
          return {
            count:
              item.menuId === action.menuId
                ? item.count <= 0
                  ? 0
                  : item.count - 1
                : item.count,
            menuId: item.menuId,
          };
        });
        // console.log(newCount);

        return {
          ...state,
          ...state.menuCount,
          menuCount: newCount,
        };
      }


      return {
        ...state,
        menuCount: [
          ...state.menuCount,
          {
            count: 1,
            menuId: action.menuId,
          },
        ],
      };

    case types.resetTheCount:
      return {
        ...state,
        menuCount: [],
      };

    case types.LIST_MENU_FETCH_START:
      return {
        ...state,
        menusLoading: true,
      };
    case types.LIST_MENU_FETCH_SUCCESS:
      // console.log("success");
      // console.log(action.menuItems);
      return {
        ...state,
        menus: action.menus,
        menusLoading: false,
      };

    case types.LIST_MENU_FETCH_FAILURE:
      return {
        ...state,
        menusError: action.menusError,
        menusLoading: false,
      };

    case types.POST_MENU_START:
      return {
        ...state,
        postMenuLoading: true,
      };

    case types.POST_MENU_SUCESS:
      return {
        ...state,
        postMenuLoading: false,
      };

    case types.POST_MENU_FAILURE:
      return {
        ...state,
        postMenuLoading: false,
        postMenuError: action.postMenuError,
      };

    case types.GET_SINGLE_MENU_START:
      return {
        ...state,
        menuLoading: false,
      };
    case types.GET_SINGLE_MENU_SUCCESS:
      return {
        ...state,
        menu: action.menu,
        menuLoading: false,
      };

    case types.GET_SINGLE_MENU_FAILURE:
      return {
        ...state,
        menuError: action.menuError,
      };

    case types.PATCH_MENU_START:
      return {
        ...state,
        menuLoading: true,
      };
    case types.PATCH_MENU_SUCCESS:
      return {
        ...state,
        menuLoading: false,
      };
    case types.PATCH_MENU_FAILURE:
      return {
        ...state,
        menuError: action.menuError,
      };

    default:
      return state;
  }
};
